import { render } from "./CIS-Icon-Group-Item.vue?vue&type=template&id=1f23e493"
import script from "./CIS-Icon-Group-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Icon-Group-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__